import { Checkbox, Typography } from '@musinsa/mds';
import { twMerge } from 'tailwind-merge';

interface AgreementItemProps {
  label: string;
  checked: boolean;
  onClick: () => void;
  showDetailButton?: boolean;
  onShowDetail?: () => void;
  className?: string;
}

export const AgreementItem = ({
  label,
  checked,
  onClick,
  showDetailButton = false,
  onShowDetail,
  className,
}: AgreementItemProps) => (
  <div className={twMerge('flex items-center justify-between py-2', className)}>
    <div className="flex items-center gap-2">
      <Checkbox checked={checked} onClick={onClick} />
      <Typography variant="body14pxReg" colorScheme="gray-600">
        {label}
      </Typography>
    </div>
    {showDetailButton && onShowDetail && (
      <Typography
        variant="body13pxReg"
        colorScheme="gray-600"
        className="cursor-pointer"
        textDecoration="underline"
        onClick={onShowDetail}
      >
        자세히
      </Typography>
    )}
  </div>
);
